import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a73d678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-menu" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "logo-title" }
const _hoisted_4 = {
  class: "user-block",
  id: "one"
}
const _hoisted_5 = { style: {"position":"relative","top":"0px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "user-block-span1" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1638440499967",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "2317",
    width: "16",
    height: "16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M512 608c-6.4 0-19.2 0-25.6-6.4l-128-128c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0L512 531.2l102.4-102.4c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8l-128 128C531.2 608 518.4 608 512 608z",
      "p-id": "2318",
      fill: "#1296db"
    })
  ])
], -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drop-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    t: "1638440499967",
    class: "icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": "2317",
    width: "16",
    height: "16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M512 608c-6.4 0-19.2 0-25.6-6.4l-128-128c-12.8-12.8-12.8-32 0-44.8s32-12.8 44.8 0L512 531.2l102.4-102.4c12.8-12.8 32-12.8 44.8 0s12.8 32 0 44.8l-128 128C531.2 608 518.4 608 512 608z",
      "p-id": "2318",
      fill: "#1296db"
    })
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("用户管理")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("项目组管理")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("退出登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, [
      _createElementVNode("img", {
        src: _ctx.logoImg,
        class: "logo-img"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.isShowGroup)
        ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userGroup, (item) => {
                    return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: item.userId,
                      onClick: ($event: any) => (_ctx.changeGroup(item))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.proGroupName), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, "当前项目组：" + _toDisplayString(_ctx.currentGroup == "" ? "无分组" : _ctx.currentGroup), 1),
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _ctx.userImg,
          class: "user-img"
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("span", null, [
        _createVNode(_component_el_dropdown, null, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (_ctx.dropList.filter((x) => x.menuName == 'user').length > 0)
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sysManage('user')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.dropList.filter((x) => x.menuName == 'user').length > 0)
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sysManage('group')))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.logOut }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.userName) + " ", 1),
              _hoisted_8
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}